export default {
  release: '19.0',
  date: 'May 2026',
  releasePostUrl: 'https://docs.gitlab.com/releases/19/gitlab-19-0-released/',
  contributors: [
    {
      name: 'Norman Debald',
      gitlabUsername: 'Modjo85',
      linkedIn: 'https://www.linkedin.com/in/norman-d-8086581b1',
      discord: '@Modjo',
    },
  ],
  writeUp: `We are excited to recognize Norman Debald, a Level 3 contributor with over 40 merged improvements across GitLab since joining in May 2022.

Nominated by [Manuel Kraft](https://gitlab.com/manuel.kraft), Staff Customer Success Manager at GitLab, Norman has contributed a wide range of improvements across GitLab, with work spanning CI/CD, security, Duo, Service Desk, and core user experience. Recent contributions include [Configurable merge train pipeline limits](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/228380), [instance-level secret push protection](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/226410), [Duo UI translation setup](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/230191), and community work that helped shape [secure webhooks with HMAC signing tokens](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/221702).

What makes Norman's contributions stand out is how clearly they reflect real-world needs. As a DevOps Engineer, Norman brings hands-on experience running GitLab at enterprise scale and turns that perspective into improvements that help make GitLab better for teams everywhere. That perspective shows up in contributions that are both technically strong and deeply practical, helping address problems teams run into when using GitLab day to day.

Thank you for your continued contributions to GitLab and the wider community!`,
};
